import React from 'react';
import dayjs from 'dayjs';
import styles from './WorkExperience.module.css';
import {PositionProps} from "utils/types";


interface WorkExperienceProps {
  experiences: PositionProps[];
}

const WorkExperience: React.FC<WorkExperienceProps> = ({ experiences }) => {
  return (
    <div className={styles.workExperience}>
      {experiences.map((experience) => (
        <div key={experience.id} className={styles.experienceItem}>
          <h3 className={styles.jobTitle}>{experience.jobTitle}</h3>
          <p className={styles.companyName}>{experience.companyName}</p>
          <p className={styles.dateRange}>
            {dayjs(experience.fromDate).format('MMMM YYYY')} - {' '}
            {experience.current ? 'Present' : dayjs(experience.toDate).format('MMMM YYYY')}
          </p>
        </div>
      ))}
    </div>
  );
};

export default WorkExperience;